var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _path10, _g6, _path11, _path12, _g7, _path13, _path14, _path15, _path16, _g8, _path17, _path18, _path19, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 97,
    viewBox: "0 0 100 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 40,
    width: 4,
    height: 1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9053 40.8171L31.4414 40.4729C31.4731 40.4729 31.5061 40.4669 31.5378 40.4656L29.0078 40.8098C28.97 40.811 28.937 40.8135 28.9053 40.8171Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5378 40.473L29.0078 40.8099H28.9956L31.5256 40.473H31.5378Z",
    fill: "#058A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5259 40.4731L28.9897 40.816L28.9128 40.8233L31.449 40.4731L31.5259 40.467",
    fill: "#04858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4487 40.4733L28.9126 40.8175H28.9053L31.4414 40.4733H31.4487Z",
    fill: "#048189"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0078 40.8098C29.159 40.8096 29.3085 40.842 29.446 40.9047C29.9244 41.1102 30.1258 41.576 30.1453 42.1416C30.1612 42.5551 30.1453 42.9698 30.1746 43.3821C30.4846 48.0779 31.2413 52.6837 32.8364 57.2555C32.5508 57.0828 32.3702 56.9758 32.1908 56.8639C29.2483 55.0286 26.8488 52.4016 24.5348 49.6566C24.4106 49.4561 24.3694 49.2154 24.4201 48.9852C25.1542 46.1747 26.4539 43.5423 28.2402 41.2477C28.4586 40.9594 28.7174 40.8159 29.0078 40.8098Z",
    fill: "#08EEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3664 56.9126L32.8303 57.2567C31.2352 52.685 30.4785 48.0792 30.1685 43.3834C30.1404 42.9711 30.155 42.5563 30.1392 42.1428C30.1197 41.5773 29.9183 41.1115 29.4399 40.9059C29.3024 40.8432 29.1529 40.8109 29.0017 40.8111L31.5378 40.473C31.689 40.4728 31.8385 40.5051 31.976 40.5678C32.4544 40.7734 32.6558 41.2392 32.6753 41.8047C32.6912 42.2182 32.6753 42.633 32.7046 43.0453C33.0146 47.735 33.7676 52.3396 35.3664 56.9126Z",
    fill: "#05C7CC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 40,
    width: 7,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3664 56.9126L32.8303 57.2567C31.2352 52.685 30.4785 48.0792 30.1685 43.3834C30.1404 42.9711 30.155 42.5563 30.1392 42.1428C30.1197 41.5773 29.9183 41.1115 29.4399 40.9059C29.3024 40.8432 29.1529 40.8109 29.0017 40.8111L31.5378 40.473C31.689 40.4728 31.8385 40.5051 31.976 40.5678C32.4544 40.7734 32.6558 41.2392 32.6753 41.8047C32.6912 42.2182 32.6753 42.633 32.7046 43.0453C33.0146 47.735 33.7676 52.3396 35.3664 56.9126Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3665 56.9126L32.8304 57.2567C32.5049 56.3122 32.21 55.3651 31.9456 54.4157L34.4817 54.0727C34.7429 55.0213 35.0378 55.9684 35.3665 56.9138",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4817 54.0715L31.9456 54.4144C31.4966 52.7782 31.1328 51.1199 30.8557 49.4462L33.3918 49.1081C33.6689 50.7818 34.0327 52.4401 34.4817 54.0763",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3917 49.1081L30.8556 49.4511C30.6115 48.0099 30.4358 46.5626 30.3027 45.1055L32.8389 44.7626C32.9719 46.222 33.1525 47.6669 33.3917 49.1081Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8388 44.7577L30.3027 45.1007C30.2531 44.529 30.2083 43.9562 30.1685 43.3821C30.1611 43.2812 30.1575 43.1802 30.155 43.0793L32.6912 42.7363C32.6912 42.8373 32.6985 42.9382 32.7046 43.0392C32.742 43.6132 32.7868 44.1861 32.8388 44.7577Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6912 42.7363L30.155 43.0793C30.1465 42.7983 30.155 42.5162 30.1428 42.234L32.679 41.8911C32.6863 42.1732 32.679 42.4554 32.6912 42.7363Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6789 41.8911L30.1428 42.234V42.1416C30.1428 42.0954 30.1428 42.0504 30.1343 42.0066L32.6692 41.6636C32.6692 41.7074 32.6765 41.7524 32.6777 41.7986V41.8911",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6692 41.6637L30.1306 42.0066C30.1306 41.9531 30.1196 41.9008 30.1111 41.8497L32.6472 41.5068C32.6558 41.5579 32.6619 41.6102 32.6667 41.6637",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6472 41.5068L30.1062 41.8497C30.0961 41.7887 30.0826 41.7282 30.0659 41.6685L32.6069 41.3243C32.6237 41.384 32.6371 41.4445 32.6472 41.5056",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6069 41.3243L30.0708 41.6673C30.0363 41.5385 29.9828 41.4156 29.9121 41.3024L32.4482 40.9595C32.5197 41.0722 32.5732 41.1953 32.6069 41.3243Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4485 40.9595L29.9123 41.3024C29.8901 41.2679 29.8661 41.2347 29.8403 41.2027L32.3765 40.8597C32.4022 40.8917 32.4263 40.925 32.4485 40.9595Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3765 40.861L29.8403 41.2027C29.822 41.1808 29.8037 41.1589 29.7842 41.1383L32.3203 40.7953C32.3398 40.816 32.3581 40.8379 32.3765 40.8597",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3203 40.7964L29.7842 41.1394C29.7671 41.1224 29.75 41.1054 29.7317 41.0896L32.2678 40.7466C32.2861 40.7624 32.3032 40.7794 32.3203 40.7964Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2678 40.7466L29.7317 41.0896L29.6804 41.047L32.2165 40.704L32.2678 40.7466Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2165 40.704L29.6804 41.047C29.6633 41.0336 29.6462 41.0202 29.6292 41.0093L32.1653 40.6651C32.1831 40.6771 32.2002 40.6901 32.2165 40.704Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1653 40.6651L29.6291 41.0093L29.5767 40.9752L32.1128 40.6323C32.1311 40.642 32.1482 40.6542 32.1653 40.6651Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1128 40.6323L29.5767 40.9752C29.5589 40.9637 29.5406 40.9532 29.5217 40.9436L32.0591 40.6006C32.0779 40.6102 32.0963 40.6208 32.114 40.6323",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0591 40.6007L29.5229 40.9436L29.4644 40.9144L32.0005 40.5715C32.02 40.5812 32.0408 40.5897 32.0591 40.6007Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 40.5715L29.4631 40.9145L29.4399 40.9047L29.3936 40.8853L31.9297 40.5423L31.9761 40.5618L31.9993 40.5715Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9297 40.5423L29.3935 40.8852L29.324 40.8597L31.8601 40.5167L31.9297 40.5423Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8601 40.5168L29.324 40.8597L29.252 40.8378L31.7881 40.4949L31.8552 40.5131",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.793 40.4986L29.2519 40.8379L29.186 40.8233L31.7222 40.4803L31.7881 40.4949",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.727 40.4839L29.1909 40.8269C29.1696 40.8221 29.148 40.8184 29.1262 40.8159L31.6624 40.473C31.6841 40.4753 31.7057 40.479 31.727 40.4839Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6623 40.473L29.1299 40.8159H29.064L31.5964 40.473H31.6623Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5969 40.473L29.0608 40.8159H29.0083L31.5383 40.473H31.5969Z",
    fill: "#05C7CC"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1117 63.1554L48.5755 63.4984H48.4144C39.0596 63.6796 30.8397 60.3909 23.866 52.6096L26.4021 52.2703C33.3722 60.054 41.5969 63.3378 50.9506 63.159L51.1117 63.1554Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 52,
    width: 29,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1117 63.1554L48.5755 63.4984H48.4144C39.0596 63.6796 30.8397 60.3909 23.866 52.6096L26.4021 52.2703C33.3722 60.054 41.5969 63.3378 50.9506 63.159L51.1117 63.1554Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1118 63.1554L48.5757 63.4984H48.4146C47.6091 63.513 46.8125 63.5024 46.0249 63.4668L48.561 63.1238C49.3495 63.1603 50.146 63.1708 50.9507 63.1554H51.1118Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5611 63.1274L46.0249 63.4704C45.2072 63.4331 44.3984 63.367 43.5986 63.2722L46.136 62.9292C46.935 63.0241 47.7433 63.0901 48.5611 63.1274Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1358 62.9292L43.5985 63.2721C42.8882 63.187 42.1852 63.0792 41.4895 62.9486L44.0256 62.6081C44.7221 62.7394 45.4255 62.8473 46.1358 62.9316",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0258 62.6081L41.4896 62.9511C40.8582 62.8319 40.2325 62.6932 39.6125 62.5351L42.1499 62.1921C42.7683 62.3502 43.3936 62.4889 44.0258 62.6081Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1498 62.1897L39.6125 62.5327C39.0291 62.3843 38.4506 62.2177 37.877 62.0329L40.4131 61.6899C40.9867 61.8747 41.5656 62.0414 42.1498 62.1897Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.413 61.6899L37.8769 62.0329C37.3293 61.8569 36.7866 61.6643 36.2488 61.4552L38.7849 61.1122C39.3235 61.3214 39.8662 61.5139 40.413 61.6899Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7851 61.1121L36.249 61.4551C35.7242 61.2508 35.2038 61.0306 34.688 60.7947L37.2241 60.4517C37.7408 60.6877 38.2611 60.9078 38.7851 61.1121Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2241 60.4518L34.6879 60.7947C34.1745 60.5604 33.666 60.3095 33.1624 60.0419L35.6985 59.6989C36.2021 59.9665 36.7107 60.2174 37.2241 60.4518Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6984 59.6989L33.1574 60.0419C32.6473 59.7719 32.142 59.4849 31.6416 59.1808L34.1826 58.8378C34.683 59.1419 35.1883 59.4289 35.6984 59.6989Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1826 58.8379L31.6464 59.1808C31.1265 58.8646 30.6115 58.5301 30.1013 58.1774L32.6374 57.8345C33.1468 58.1872 33.6618 58.5216 34.1826 58.8379Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6374 57.8344L30.1061 58.1774C29.5667 57.8044 29.0333 57.4096 28.5061 56.9928L31.0374 56.6486C31.5646 57.0646 32.0979 57.4594 32.6374 57.8332",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0375 56.6487L28.5014 56.9916C27.9229 56.536 27.3533 56.0543 26.7927 55.5468L29.3289 55.2038C29.8927 55.7106 30.4623 56.1922 31.0375 56.6487Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3226 55.205L26.7865 55.5541C26.1405 54.9743 25.5046 54.3597 24.8789 53.7103L27.4211 53.3649C28.0468 54.0135 28.6827 54.6281 29.3287 55.2087",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4217 53.3649L24.8855 53.7078C24.5446 53.3535 24.207 52.9886 23.8726 52.6132L26.4026 52.2703C26.737 52.644 27.0747 53.0089 27.4156 53.3649",
    fill: "#05C7CC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 13,
    width: 4,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3108 14.0811L44.8469 13.7381C44.9229 13.7273 44.9996 13.7212 45.0764 13.7198L42.539 14.0628C42.4627 14.0648 42.3865 14.0709 42.3108 14.0811Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0776 13.7162L42.5403 14.0592H42.5134L45.0496 13.7162H45.0776Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0498 13.7161L42.5136 14.0591C42.4526 14.0591 42.3916 14.0664 42.3293 14.0737L44.8655 13.7307C44.9277 13.7234 44.9875 13.7186 45.0498 13.7161Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8652 13.7324L42.3291 14.0815H42.3108L44.8469 13.7385H44.864",
    fill: "#8A8A8A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 33,
    width: 5,
    height: 9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5588 40.8731L45.0227 41.2161C46.1272 41.0665 46.8021 39.9889 46.7192 38.2692C46.652 36.879 46.5788 35.4877 46.5044 34.0124L49.0405 33.6694C49.1149 35.1435 49.1882 36.5348 49.2565 37.9262C49.3432 39.6459 48.667 40.7235 47.5588 40.8731Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5588 40.8731L45.0227 41.216C45.3836 41.1708 45.7202 41.0104 45.982 40.7587L48.5181 40.4158C48.2563 40.6674 47.9198 40.8279 47.5588 40.8731Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5217 40.4158L45.9856 40.7588C46.0328 40.7133 46.0776 40.6654 46.1198 40.6153L48.6572 40.2723C48.615 40.3224 48.5702 40.3703 48.5229 40.4158",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6572 40.2723L46.1211 40.6153C46.1553 40.5752 46.1882 40.5326 46.22 40.4937L48.7561 40.1507C48.7243 40.1945 48.6914 40.237 48.6572 40.2723Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7549 40.1458L46.2163 40.4888C46.2444 40.4498 46.2712 40.4085 46.2969 40.3671L48.833 40.0242C48.8074 40.0667 48.7805 40.1081 48.7524 40.1458",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8354 40.023L46.2993 40.366C46.3237 40.327 46.3469 40.2857 46.3701 40.2443L48.9014 39.9001C48.8782 39.9427 48.855 39.9841 48.8306 40.0218",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9014 39.9001L46.3652 40.2431C46.386 40.203 46.4067 40.1616 46.4263 40.1215L48.9624 39.7785C48.9429 39.8211 48.9221 39.8624 48.9014 39.9001Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9673 39.7761L46.4312 40.119C46.4507 40.0765 46.469 40.0339 46.4873 39.9889L49.0234 39.6459C49.0051 39.6909 48.9868 39.7335 48.9673 39.7761Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0234 39.6459L46.4873 39.9865C46.5044 39.9427 46.5215 39.8965 46.5373 39.8502L49.0735 39.5073C49.0576 39.5535 49.0405 39.5997 49.0234 39.6435",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0735 39.5097L46.5374 39.8527C46.5532 39.8053 46.5691 39.7566 46.5825 39.7067L49.1186 39.3638C49.1052 39.4136 49.0893 39.4623 49.0735 39.5097Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1186 39.3638L46.5825 39.7068C46.5972 39.6557 46.6118 39.6022 46.624 39.5487L49.1601 39.2057C49.1479 39.2592 49.1333 39.3127 49.1186 39.3638Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1602 39.2057L46.624 39.5486C46.637 39.4919 46.6492 39.4335 46.6606 39.3735L49.1968 39.0305C49.1862 39.0905 49.174 39.1489 49.1602 39.2057Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1968 39.0305L46.6606 39.3784C46.6716 39.3151 46.6826 39.2495 46.6912 39.1838L49.2273 38.8408C49.2187 38.9065 49.2078 38.9722 49.1968 39.0354",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2273 38.8359L46.6912 39.1789C46.7009 39.1059 46.7082 39.0329 46.7144 38.9575L49.2505 38.6146C49.2444 38.69 49.2371 38.7629 49.2273 38.8359Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2505 38.6146L46.7144 38.9576C46.7217 38.8724 46.7253 38.7873 46.7278 38.6985L49.2676 38.3555C49.2676 38.4443 49.2615 38.5294 49.2541 38.6146",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2676 38.3555L46.7314 38.6985C46.7314 38.5976 46.7314 38.493 46.7314 38.3871L49.2676 38.0405C49.2676 38.1463 49.2676 38.2509 49.2676 38.3519",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2675 38.0404L46.7314 38.3834C46.7314 38.3445 46.7314 38.3056 46.7314 38.2618C46.6643 36.8716 46.5911 35.4803 46.5166 34.005L49.0527 33.662C49.1272 35.1361 49.2004 36.5275 49.2688 37.9188V38.0404",
    fill: "#D1D1D1"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4368 19.6939L44.9019 20.0405C44.8482 18.9897 44.7981 17.9401 44.742 16.8905C44.6468 15.1136 43.7217 14.0397 42.5452 14.0628L45.0776 13.7162C46.259 13.6931 47.1829 14.767 47.2745 16.5439C47.3343 17.5935 47.3843 18.6431 47.4368 19.6939Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 13,
    width: 6,
    height: 8
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4368 19.6939L44.9019 20.0405C44.8482 18.9897 44.7981 17.9401 44.742 16.8905C44.6468 15.1136 43.7217 14.0397 42.5452 14.0628L45.0776 13.7162C46.259 13.6931 47.1829 14.767 47.2745 16.5439C47.3343 17.5935 47.3843 18.6431 47.4368 19.6939Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4367 19.6939L44.9018 20.0405C44.8481 18.9897 44.7981 17.9401 44.7419 16.8905C44.7419 16.8224 44.7334 16.7567 44.7273 16.6898L47.2634 16.3469C47.2691 16.4125 47.274 16.4794 47.2781 16.5475C47.3342 17.5971 47.3842 18.6467 47.438 19.6975",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2634 16.3433L44.7273 16.6862C44.7163 16.5646 44.7004 16.443 44.6809 16.3214L47.217 15.9784C47.2366 16.1 47.2524 16.2143 47.2634 16.3433Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.217 15.9832L44.6809 16.3262C44.6574 16.1815 44.626 16.0382 44.5869 15.8969L47.123 15.5539C47.1622 15.6952 47.1935 15.8385 47.217 15.9832Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.123 15.5539L44.5868 15.8969C44.5041 15.5861 44.3754 15.2893 44.2048 15.0164L46.741 14.6734C46.9115 14.9464 47.0403 15.2431 47.123 15.5539Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7412 14.6734L44.205 15.0163C44.1537 14.9352 44.0974 14.8572 44.0366 14.7828L46.5728 14.4459C46.6336 14.5203 46.6898 14.5983 46.7412 14.6794",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5727 14.4459L44.0366 14.7889C43.9963 14.7403 43.9548 14.6928 43.9146 14.649L46.4482 14.3C46.491 14.3438 46.5325 14.3912 46.5703 14.4399",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4482 14.3L43.9121 14.643C43.8773 14.6059 43.8406 14.5706 43.8022 14.5372L46.3384 14.1942C46.3768 14.2276 46.4134 14.2629 46.4482 14.3Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3384 14.1942L43.8022 14.5372C43.7705 14.508 43.7375 14.48 43.7034 14.4533L46.2395 14.1103C46.2737 14.137 46.3066 14.165 46.3384 14.1942Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2395 14.1103L43.7034 14.4532C43.6716 14.4277 43.6399 14.4046 43.6069 14.3815L46.1431 14.0385C46.176 14.0616 46.2077 14.0847 46.2395 14.1103Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.143 14.0385L43.6069 14.3815C43.5752 14.3596 43.5435 14.3389 43.5117 14.3195L46.0478 13.9765L46.143 14.0385Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0478 13.9765L43.5117 14.3243C43.4812 14.3061 43.4507 14.2879 43.4189 14.2721L45.9551 13.9291C45.9868 13.9449 46.0173 13.9631 46.0478 13.9814",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9551 13.9242L43.4189 14.2672C43.3872 14.2501 43.3567 14.2343 43.325 14.2197L45.8611 13.8768C45.8928 13.8914 45.9245 13.9072 45.9551 13.9242Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8611 13.8767L43.3249 14.2197C43.2932 14.2063 43.2615 14.1917 43.2285 14.1796L45.7646 13.8378C45.7976 13.85 45.8293 13.8646 45.8611 13.878",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7646 13.8378L43.2285 14.1808L43.1296 14.1455L45.6658 13.8026L45.7646 13.8378Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6657 13.8013L43.1296 14.1443C43.0954 14.1334 43.0601 14.1236 43.0259 14.1151L45.562 13.7722C45.5962 13.7807 45.6316 13.7904 45.6657 13.8013Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.562 13.7721L43.0259 14.1151C42.9893 14.1051 42.9522 14.097 42.9148 14.0908L45.4521 13.7478C45.4888 13.7539 45.5254 13.7624 45.562 13.7721Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4524 13.748L42.9211 14.0909C42.8821 14.0824 42.8418 14.0764 42.7991 14.0715L45.3352 13.7285C45.3755 13.7285 45.4158 13.7395 45.4572 13.748",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3315 13.7283L42.799 14.0713C42.7551 14.0713 42.7112 14.0628 42.666 14.0616L45.1985 13.7162C45.2436 13.7162 45.2876 13.7162 45.3315 13.7259",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.198 13.7162L42.6618 14.0592C42.6216 14.0592 42.5813 14.0592 42.5398 14.0592L45.0771 13.7162C45.1174 13.7162 45.1577 13.7162 45.1992 13.7162",
    fill: "#B5B5B5"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3222 83.0405L52.7861 83.3835C53.1739 83.3246 53.5425 83.1764 53.8626 82.9505C59.611 79.0667 65.3557 75.1773 71.0968 71.2821C72.1159 70.5925 72.6455 69.5904 72.5076 68.1747C72.3734 66.787 71.6618 65.904 70.5634 65.3908C64.191 62.4151 57.8185 59.4406 51.446 56.4674C51.1009 56.2995 50.7219 56.2121 50.3378 56.212C50.2627 56.2137 50.1877 56.2198 50.1133 56.2302L52.6494 55.8873C52.7238 55.8769 52.7988 55.8708 52.874 55.869C53.258 55.8691 53.637 55.9565 53.9822 56.1244C60.3587 59.0904 66.7316 62.0624 73.1008 65.0405C74.1992 65.5537 74.9095 66.4367 75.0438 67.8244C75.1817 69.2401 74.652 70.2423 73.6329 70.9319C67.8853 74.8205 62.1406 78.7108 56.3987 82.6027C56.079 82.8303 55.7104 82.9802 55.3222 83.0405Z",
    fill: "#05C7CC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 55,
    width: 26,
    height: 29
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3222 83.0405L52.7861 83.3835C53.1739 83.3246 53.5425 83.1764 53.8626 82.9505C59.611 79.0667 65.3557 75.1773 71.0968 71.2821C72.1159 70.5925 72.6455 69.5904 72.5076 68.1747C72.3734 66.787 71.6618 65.904 70.5634 65.3908C64.191 62.4151 57.8185 59.4406 51.446 56.4674C51.1009 56.2995 50.7219 56.2121 50.3378 56.212C50.2627 56.2137 50.1877 56.2198 50.1133 56.2302L52.6494 55.8873C52.7238 55.8769 52.7988 55.8708 52.874 55.869C53.258 55.8691 53.637 55.9565 53.9822 56.1244C60.3587 59.0904 66.7316 62.0624 73.1008 65.0405C74.1992 65.5537 74.9095 66.4367 75.0438 67.8244C75.1817 69.2401 74.652 70.2423 73.6329 70.9319C67.8853 74.8205 62.1406 78.7108 56.3987 82.6027C56.079 82.8303 55.7104 82.9802 55.3222 83.0405Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3223 83.0405L52.7861 83.3834C53.1739 83.3246 53.5425 83.1763 53.8626 82.9505C59.611 79.0667 65.3557 75.1772 71.0968 71.2821C71.2763 71.1619 71.4453 71.0268 71.6021 70.8783L74.1382 70.5353C73.9826 70.6837 73.8148 70.8188 73.6366 70.9391C67.8866 74.8229 62.1406 78.7107 56.3987 82.6026C56.0786 82.8285 55.71 82.9768 55.3223 83.0356",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1345 70.5305L71.6021 70.8783C71.6832 70.8014 71.7602 70.7202 71.8327 70.6351L74.3688 70.2921C74.2964 70.3772 74.2194 70.4584 74.1382 70.5354",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 70.2848L71.8291 70.6278C71.8816 70.5658 71.9316 70.5001 71.9792 70.4344L74.5153 70.0914C74.4678 70.1571 74.4177 70.2228 74.3652 70.2848Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5154 70.0914L71.9792 70.4344C72.0171 70.3809 72.0537 70.3249 72.0879 70.269L74.624 69.926C74.5898 69.982 74.5532 70.0367 74.5154 70.0914Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6238 69.926L72.0901 70.2702C72.1206 70.2203 72.1499 70.1705 72.178 70.1182L74.7141 69.7752C74.686 69.8275 74.6567 69.8774 74.6262 69.9272",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7117 69.774L72.1755 70.117C72.1999 70.0695 72.2244 70.0221 72.2463 69.9722L74.7825 69.6293C74.7605 69.6791 74.7361 69.7266 74.7117 69.774Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7825 69.6292L72.2463 69.9722C72.2683 69.926 72.2878 69.8798 72.3074 69.8311L74.8435 69.4882C74.824 69.5368 74.8044 69.583 74.7825 69.6292Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8435 69.4882L72.3074 69.8312C72.3261 69.7858 72.3432 69.7395 72.3586 69.6925L74.8972 69.3495C74.8817 69.3966 74.8647 69.4428 74.8459 69.4882",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8972 69.3495L72.3611 69.6925C72.377 69.6463 72.3916 69.5988 72.405 69.5514L74.9411 69.2084C74.9277 69.2559 74.9131 69.3033 74.8972 69.3495Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9387 69.2084L72.4026 69.5514C72.416 69.504 72.4294 69.4553 72.4404 69.4055L74.9766 69.0625C74.9656 69.1124 74.9521 69.161 74.9387 69.2084Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9766 69.0625L72.4404 69.4055C72.4526 69.3556 72.4624 69.3045 72.4722 69.2534L75.0083 68.9105C74.9985 68.9615 74.9888 69.0126 74.9766 69.0625Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0083 68.9105L72.4722 69.2534C72.4819 69.1999 72.4905 69.1452 72.4978 69.0905L75.0339 68.7475C75.0266 68.8022 75.0181 68.857 75.0083 68.9105Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0339 68.7475L72.4978 69.0905C72.5051 69.0321 72.5112 68.9689 72.5161 68.9129L75.0535 68.5675C75.0535 68.6283 75.0413 68.6891 75.0339 68.7451",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0535 68.5675L72.5161 68.9105C72.5222 68.846 72.5259 68.7791 72.5271 68.711L75.0632 68.368C75.0632 68.4362 75.0632 68.5018 75.0535 68.5675Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0632 68.3705L72.5271 68.7135C72.5271 68.638 72.5271 68.5602 72.5271 68.4824L75.0632 68.1382C75.0632 68.2172 75.0632 68.2951 75.0632 68.3705Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0632 68.1382L72.5271 68.4824C72.5271 68.3899 72.5186 68.2951 72.51 68.199L75.0461 67.856C75.0547 67.9521 75.0608 68.047 75.0632 68.1382Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0461 67.856L72.51 68.2026C72.51 68.1929 72.51 68.1832 72.51 68.1735C72.5002 68.0701 72.4868 67.9679 72.4697 67.8694L75.0059 67.5264C75.0229 67.6249 75.0364 67.7271 75.0461 67.8305C75.0467 67.8402 75.0467 67.8499 75.0461 67.8597",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0034 67.5228L72.4673 67.8657C72.4448 67.7318 72.4155 67.599 72.3794 67.468L74.9155 67.1251C74.9516 67.256 74.981 67.3888 75.0034 67.5228Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9157 67.1251L72.3796 67.4729C72.2947 67.1603 72.163 66.8623 71.989 66.5887L74.5312 66.2409C74.7052 66.5144 74.8369 66.8125 74.9218 67.1251",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5312 66.2409L71.9951 66.5839C71.9348 66.4902 71.8691 66.4001 71.7986 66.3139L74.3347 65.9709C74.4053 66.0571 74.4709 66.1473 74.5312 66.2409Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3286 65.9709L71.7924 66.3138C71.74 66.2494 71.685 66.1922 71.6277 66.129L74.165 65.786C74.2224 65.8444 74.2773 65.9076 74.3298 65.9709",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.165 65.786L71.6277 66.1351C71.5764 66.0816 71.5227 66.0293 71.4678 65.9806L74.0039 65.6376C74.0588 65.6863 74.1125 65.7386 74.1638 65.7921",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0039 65.6316L71.4677 65.9745C71.4153 65.9271 71.3616 65.8821 71.3054 65.8371L73.8415 65.4941C73.8977 65.5391 73.9514 65.5841 74.0039 65.6316Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8415 65.4941L71.3054 65.8371C71.2505 65.7945 71.1943 65.7532 71.1357 65.7155L73.6768 65.3688C73.7353 65.4102 73.7915 65.4515 73.8464 65.4905",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6767 65.3689L71.1406 65.7118C71.082 65.6717 71.0185 65.6316 70.9587 65.5902L73.4949 65.2473C73.5571 65.285 73.6169 65.3251 73.6767 65.3689Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4899 65.2509L70.9538 65.5938C70.8891 65.5549 70.822 65.5172 70.7549 65.4807L73.291 65.1378C73.3581 65.1742 73.4253 65.2119 73.4899 65.2509Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2912 65.1378L70.755 65.4808C70.6928 65.4479 70.633 65.4163 70.5634 65.3859C64.191 62.4102 57.8185 59.4358 51.446 56.4625L51.4265 56.454L53.9626 56.111L53.9822 56.1195C60.3587 59.0887 66.7316 62.0624 73.1008 65.0405C73.1659 65.0713 73.2293 65.1029 73.2912 65.1353",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9626 56.111L51.4265 56.454C51.3703 56.4284 51.3154 56.4053 51.2593 56.3834L53.7954 56.0405C53.8515 56.0624 53.9065 56.0855 53.9626 56.111Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7954 56.0405L51.2592 56.3835C51.2055 56.3628 51.1518 56.3433 51.0981 56.3263L53.6343 55.9833C53.688 56.0004 53.7417 56.0198 53.7954 56.0405Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6342 55.9833L51.0981 56.3263C51.0456 56.3092 50.9932 56.2946 50.9419 56.2813L53.478 55.9383C53.5293 55.9517 53.5818 55.9663 53.6342 55.9833Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.478 55.9383L50.9419 56.2837C50.8894 56.2703 50.8381 56.2582 50.7869 56.2484L53.323 55.9055C53.3743 55.9152 53.4255 55.9273 53.478 55.9407",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.323 55.9032L50.7868 56.2461C50.7344 56.2364 50.6831 56.2291 50.6318 56.223L53.1728 55.8801C53.2241 55.8861 53.2754 55.8934 53.3278 55.9032",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1731 55.8799L50.6369 56.2229C50.5832 56.2168 50.5308 56.2119 50.4795 56.2095L53.0156 55.8665C53.0669 55.8665 53.1194 55.8738 53.1731 55.8799Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0107 55.8665L50.4746 56.2095C50.4282 56.2095 50.383 56.2095 50.3379 56.2095H50.3074L52.8435 55.8665H52.874C52.9192 55.8665 52.9643 55.8665 53.0107 55.8665Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8437 55.8653L50.3076 56.2083C50.2466 56.2083 50.1855 56.2156 50.127 56.2229L52.6631 55.8799C52.7229 55.8726 52.7851 55.8677 52.8437 55.8653Z",
    fill: "#05C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6628 55.8801L50.1218 56.223H50.1084L52.6445 55.8801H52.658",
    fill: "#05C7CC"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8659 52.6132C30.836 60.397 39.0595 63.6808 48.4144 63.502H48.5755C48.495 61.9088 48.4083 60.442 48.3497 58.9752C48.2826 57.3151 49.1406 56.2339 50.3379 56.2108C50.7219 56.2109 51.1009 56.2983 51.446 56.4662C57.8201 59.4346 64.1926 62.409 70.5634 65.3896C71.6619 65.9028 72.3734 66.7858 72.5076 68.1735C72.6456 69.5892 72.1159 70.5913 71.0968 71.2809C65.3508 75.168 59.6061 79.0574 53.8626 82.9493C53.4819 83.2207 53.0304 83.3761 52.5628 83.3969C51.3936 83.42 50.4428 82.368 50.3476 80.6677C50.2866 79.5889 50.2378 78.5101 50.1804 77.3839C49.7484 77.3681 49.3908 77.3839 49.0381 77.3353C46.9291 77.0494 44.786 76.9619 42.7185 76.4134C36.3391 74.7192 31.002 70.9404 27.1038 64.6416C24.8838 61.0598 23.5706 57.1351 23.8659 52.6132Z",
    fill: "#08EEFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2351 40.1993C62.5488 40.3878 62.7318 40.4924 62.9112 40.6043C65.8514 42.4395 68.2483 45.0666 70.5562 47.8164C70.6856 47.9709 70.6881 48.3881 70.6222 48.6301C69.9054 51.2911 68.6828 53.7902 67.0206 55.9918C66.7398 56.364 66.4396 56.6389 66.0625 56.6462C65.915 56.6462 65.7693 56.613 65.6365 56.5489C65.0324 56.2691 64.9702 55.6586 64.9299 54.997C64.8298 53.3709 64.7322 51.74 64.5284 50.1236C64.1073 46.7827 63.4458 43.4952 62.2351 40.1993Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6877 56.2971L66.1516 56.6401C66.4872 56.5939 66.7618 56.3336 67.0206 55.9919C68.6841 53.7905 69.908 51.2914 70.6258 48.6301C70.6917 48.3869 70.6893 47.9709 70.5599 47.8165C68.252 45.0666 65.855 42.4396 62.9149 40.6043C62.7355 40.4924 62.5488 40.3878 62.2388 40.1993L64.7676 39.8563C65.0825 40.0448 65.2643 40.1494 65.4437 40.2613C68.3838 42.0966 70.7808 44.7236 73.0887 47.4735C73.2181 47.6279 73.2205 48.0439 73.1546 48.2859C72.438 50.9473 71.2154 53.4469 69.553 55.6489C69.2979 55.9906 69.0233 56.2509 68.6877 56.2971Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 39,
    width: 12,
    height: 18
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6877 56.2971L66.1516 56.6401C66.4872 56.5939 66.7618 56.3336 67.0206 55.9919C68.6841 53.7905 69.908 51.2914 70.6258 48.6301C70.6917 48.3869 70.6893 47.9709 70.5599 47.8165C68.252 45.0666 65.855 42.4396 62.9149 40.6043C62.7355 40.4924 62.5488 40.3878 62.2388 40.1993L64.7676 39.8563C65.0825 40.0448 65.2643 40.1494 65.4437 40.2613C68.3838 42.0966 70.7808 44.7236 73.0887 47.4735C73.2181 47.6279 73.2205 48.0439 73.1546 48.2859C72.438 50.9473 71.2154 53.4469 69.553 55.6489C69.2979 55.9906 69.0233 56.2509 68.6877 56.2971Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6877 56.2971L66.1516 56.6401C66.3743 56.5995 66.578 56.4887 66.7326 56.3239L69.2699 55.9797C69.1151 56.145 68.911 56.2563 68.6877 56.2971Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.27 55.9797L66.7327 56.3239C66.7926 56.2658 66.8492 56.2045 66.9023 56.1402L69.4384 55.7972C69.3857 55.8611 69.3295 55.922 69.27 55.9797Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4382 55.7972L66.9021 56.1402C66.9424 56.0928 66.9814 56.0441 67.0241 55.9918C67.1478 55.8297 67.2699 55.6647 67.3903 55.4968L69.9276 55.1539C69.808 55.3209 69.686 55.4859 69.5615 55.6489C69.5224 55.7012 69.4834 55.7498 69.4395 55.7972",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9204 55.1539L67.3831 55.4969C67.6686 55.0955 67.94 54.6853 68.1971 54.2661L70.7332 53.9231C70.4769 54.3427 70.2048 54.7526 69.9204 55.1539Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7332 53.9231L68.197 54.266C68.424 53.8963 68.6396 53.5193 68.8439 53.135L71.38 52.792C71.175 53.1763 70.9593 53.5533 70.7332 53.9231Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3801 52.792L68.844 53.135C69.0311 52.7839 69.2089 52.4251 69.3773 52.0586L71.9135 51.7156C71.745 52.0805 71.5669 52.4454 71.3801 52.792Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9133 51.7157L69.3772 52.0586C69.5399 51.714 69.6905 51.3634 69.8288 51.0066L72.3649 50.6636C72.2233 51.0204 72.0728 51.3711 71.9133 51.7157Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.365 50.6636L69.8289 51.0066C69.9655 50.662 70.0945 50.3125 70.2157 49.9582L72.7519 49.6152C72.6306 49.9704 72.5017 50.3198 72.365 50.6636Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7519 49.6152L70.2158 49.9594C70.3346 49.6099 70.4457 49.2552 70.549 48.8952L73.0851 48.551C72.9818 48.9118 72.8707 49.267 72.7519 49.6164",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.085 48.5498L70.5488 48.894L70.6221 48.6301C70.6221 48.6191 70.6221 48.6082 70.6306 48.5973L73.1667 48.2567C73.1646 48.2674 73.1617 48.278 73.1582 48.2883L73.085 48.5523",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1667 48.2568L70.6257 48.5973L70.6367 48.545L73.1728 48.202L73.1619 48.2543",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1777 48.202L70.6416 48.545C70.6416 48.5243 70.6489 48.5024 70.6514 48.4805L73.1887 48.1351C73.1887 48.157 73.1826 48.1789 73.179 48.1996",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1887 48.1351L70.6526 48.4781C70.6526 48.4537 70.6587 48.4282 70.6611 48.4014L73.1973 48.0585C73.1973 48.0852 73.1973 48.1096 73.1887 48.1351Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.196 48.0609L70.6599 48.4039C70.6599 48.3759 70.6599 48.3479 70.6599 48.32L73.196 47.977C73.196 48.0054 73.196 48.0333 73.196 48.0609Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1997 47.977L70.6636 48.32C70.6636 48.2895 70.6636 48.2604 70.6636 48.2312L73.2009 47.8918C73.2009 47.921 73.2009 47.9502 73.2009 47.9806",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2009 47.8919L70.6636 48.2349C70.6636 48.2045 70.6636 48.1753 70.6636 48.1461L73.1997 47.8031C73.1997 47.8323 73.1997 47.8615 73.2058 47.8919",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1948 47.7994L70.6587 48.1424C70.6587 48.1132 70.6587 48.0852 70.6477 48.0573L73.1887 47.7143C73.1887 47.7423 73.1973 47.7702 73.1997 47.7994",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1887 47.7143L70.6526 48.0573C70.648 48.0282 70.6419 47.9993 70.6343 47.9709L73.1704 47.6279C73.178 47.6564 73.1842 47.6852 73.1887 47.7143Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1655 47.628L70.6257 47.9709C70.6136 47.9281 70.5956 47.8872 70.572 47.8493L73.1082 47.5063C73.1322 47.5461 73.1503 47.5891 73.1619 47.6341",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1118 47.5002L70.5757 47.8432L70.5586 47.8189L73.0947 47.4759C73.1008 47.4837 73.1065 47.4918 73.1118 47.5002Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0949 47.4759L70.5588 47.8189C69.6312 46.7134 68.689 45.6297 67.7029 44.6057L70.239 44.2627C71.2251 45.2855 72.1674 46.3704 73.0949 47.4759Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2365 44.2603L67.6967 44.6081C67.1499 44.0413 66.5897 43.494 66.01 42.9735L68.551 42.6245C69.1307 43.1462 69.6909 43.6935 70.2377 44.2603",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.551 42.6245L66.0149 42.9686C65.6081 42.5989 65.1878 42.2442 64.7542 41.9045L67.2891 41.5676C67.7195 41.9073 68.1397 42.2616 68.5498 42.6305",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2891 41.5675L64.753 41.9105C64.4047 41.6356 64.0488 41.3721 63.6851 41.12L66.2224 40.777C66.5861 41.0283 66.9417 41.2918 67.2891 41.5675Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2225 40.7709L63.6851 41.1139C63.4313 40.9376 63.1738 40.7685 62.9114 40.6043L62.8259 40.552L65.3621 40.209L65.4475 40.2613C65.7099 40.4255 65.9674 40.5946 66.2225 40.7709Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3619 40.209L62.8258 40.552C62.6708 40.4571 62.4999 40.3586 62.2351 40.1993L64.7676 39.8563C65.0324 40.0156 65.2033 40.1142 65.3583 40.209",
    fill: "#B5B5B5"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5403 14.0591C43.7218 14.036 44.6469 15.11 44.7372 16.8868C44.7933 17.9364 44.8434 18.986 44.8971 20.0368C46.1065 20.1171 47.222 20.1585 48.3339 20.2728C53.3207 20.7873 57.9536 22.6201 62.1081 26.0595C66.2845 29.516 69.3918 33.9005 70.8356 39.6702C71.2604 41.3729 71.2213 43.0683 71.2555 44.9668C67.8919 41.0093 64.0877 38.2582 59.8087 36.4205C55.8813 34.7324 51.8671 33.8859 47.6712 33.9674C47.2839 33.9747 46.8946 33.9901 46.5032 34.0136C46.5776 35.4877 46.6509 36.879 46.718 38.2704C46.8071 40.1068 46.0309 41.2112 44.7921 41.2355C44.3406 41.231 43.8961 41.1242 43.4923 40.9229C37.1996 37.9975 30.9097 35.0652 24.6227 32.126C23.5011 31.6043 22.7358 30.7639 22.5759 29.3458C22.4173 27.8595 22.9897 26.844 24.0539 26.1216C29.7649 22.2662 35.4726 18.4039 41.1771 14.5347C41.5756 14.2478 42.0493 14.0826 42.5403 14.0591Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7988 44.6239L71.2603 44.973C71.2261 43.0744 71.2603 41.373 70.8404 39.6763C69.3966 33.9066 66.2893 29.5221 62.1129 26.0657C57.9633 22.6262 53.3255 20.7934 48.3387 20.2789C47.2268 20.1646 46.1113 20.1232 44.9019 20.043L47.4368 19.6939C48.6462 19.7742 49.7618 19.8155 50.8736 19.9299C55.858 20.4443 60.4958 22.2772 64.6453 25.7166C68.8206 29.1731 71.9279 33.5576 73.3717 39.3273C73.7988 41.0239 73.7622 42.7254 73.7988 44.6239Z",
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1785_2324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 19,
    width: 30,
    height: 26
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7988 44.6239L71.2603 44.973C71.2261 43.0744 71.2603 41.373 70.8404 39.6763C69.3966 33.9066 66.2893 29.5221 62.1129 26.0657C57.9633 22.6262 53.3255 20.7934 48.3387 20.2789C47.2268 20.1646 46.1113 20.1232 44.9019 20.043L47.4368 19.6939C48.6462 19.7742 49.7618 19.8155 50.8736 19.9299C55.858 20.4443 60.4958 22.2772 64.6453 25.7166C68.8206 29.1731 71.9279 33.5576 73.3717 39.3273C73.7988 41.0239 73.7622 42.7254 73.7988 44.6239Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1785_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7988 44.6239L71.2602 44.9729C71.248 44.3028 71.2456 43.657 71.2273 43.027L73.7634 42.684C73.7817 43.314 73.7842 43.9598 73.7964 44.63",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7634 42.678L71.2273 43.027C71.2139 42.5272 71.1907 42.037 71.1467 41.5542L73.6829 41.2027C73.7268 41.6892 73.75 42.1757 73.7634 42.6755",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6828 41.2027L71.1467 41.5457C71.115 41.2027 71.0735 40.8622 71.0173 40.5229L73.5547 40.1823C73.6108 40.5216 73.6535 40.861 73.6841 41.2052",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5546 40.1823L71.0185 40.5253C70.9713 40.2391 70.9123 39.9553 70.8415 39.6739C70.7878 39.4599 70.7317 39.2474 70.6731 39.0366L73.2104 38.6937C73.2674 38.9037 73.3231 39.1161 73.3776 39.331C73.4484 39.6156 73.5074 39.8993 73.5546 40.1823Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2094 38.69L70.672 39.0329C70.0121 36.6117 68.9857 34.3048 67.6282 32.1917L70.1643 31.8488C71.5218 33.962 72.5486 36.2688 73.2094 38.69Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1642 31.8488L67.6281 32.1917C67.1239 31.4075 66.5763 30.6519 65.9878 29.9284L68.5239 29.5854C69.1149 30.3084 69.6646 31.0641 70.1703 31.8488",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5178 29.5854L65.9878 29.9284C65.5256 29.3608 65.0399 28.8143 64.5305 28.2889L67.0605 27.9459C67.5691 28.4729 68.0548 29.0194 68.5178 29.5854Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0605 27.946L64.5232 28.2889C64.0537 27.8024 63.5655 27.3314 63.0586 26.8757L65.5947 26.5327C66.1008 26.9884 66.5894 27.4595 67.0605 27.946Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5959 26.5327L63.0586 26.8757C62.7502 26.5984 62.4345 26.3264 62.1115 26.0596C61.9369 25.9137 61.76 25.7714 61.583 25.6327L64.1191 25.2897C64.2965 25.4284 64.4731 25.5707 64.6488 25.7166C64.9694 25.9834 65.2847 26.2554 65.5947 26.5327",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1203 25.2897L61.5842 25.6351C61.1424 25.2873 60.6949 24.9573 60.2417 24.6451L62.7815 24.2973C63.2331 24.6095 63.6806 24.9395 64.124 25.2873",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7817 24.2973L60.2517 24.6427C59.8245 24.3459 59.3925 24.0654 58.9556 23.801L61.4917 23.4581C61.9286 23.7232 62.3607 24.0037 62.7878 24.2997",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4856 23.4581L58.9495 23.8011C58.5264 23.5433 58.0988 23.3 57.6667 23.0714L60.2029 22.7284C60.6349 22.957 61.0625 23.2003 61.4856 23.4581Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2029 22.7284L57.6667 23.0713C57.2396 22.8451 56.8083 22.6323 56.373 22.4328L58.9092 22.0898C59.3437 22.2893 59.7749 22.5021 60.2029 22.7284Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9092 22.0898L56.373 22.4328C55.9337 22.2317 55.4902 22.0444 55.0427 21.8709L57.5801 21.528C58.0268 21.7015 58.4698 21.8888 58.9092 22.0898Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.58 21.528L55.0427 21.871C54.5838 21.6926 54.1208 21.5304 53.6538 21.3845L56.1912 21.0415C56.6574 21.1907 57.1203 21.3529 57.58 21.528Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1911 21.0354L53.6538 21.3784C53.1656 21.2203 52.6774 21.0792 52.177 20.9515L54.7131 20.6085C55.2099 20.7301 55.7017 20.8773 56.1911 21.0354Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7131 20.6085L52.1769 20.9515C51.6464 20.8161 51.1115 20.6977 50.572 20.5963L53.1082 20.2534C53.6476 20.3555 54.1826 20.4739 54.7131 20.6085Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1083 20.2534L50.5722 20.5964C49.9806 20.4861 49.3826 20.3945 48.7781 20.3215L51.3154 19.9785C51.9183 20.0507 52.516 20.1423 53.1083 20.2534Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3157 19.9785L48.7795 20.3215C48.6343 20.3044 48.4866 20.2874 48.3402 20.2728C47.2283 20.1585 46.1128 20.1172 44.9033 20.0369L47.437 19.6939C48.6465 19.7742 49.762 19.8155 50.8738 19.9299C51.0215 19.9444 51.168 19.9615 51.3144 19.9785",
    fill: "#B5B5B5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.bb3ded34c8501310b4d91c803d3536ea.svg";
export { ForwardRef as ReactComponent };